<template>
    <span class="badge rounded-pill bg-success approved-badge">Approved</span>
</template>

<script>
export default {
    name: "proposition-approved-badge",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>
.approved-badge{
     /*badge-color: #396f3a;*/
}
</style>
